<template>
  <chart :option="calOptions" ref="chart" class="chart-cont"></chart>
</template>

<script>
import lodash, { merge } from 'lodash';
import numeral from 'numeral';
import dayjs from 'dayjs';
import Chart from '@/components/echarts/chart.vue';
import { optionGen } from '@/utils/helper';
import { getCharFromInt } from '@/utils/common';
import { DEFAULT_TIME_UNIT_ENUM } from '@/views/analysis/retention-analysis/components/config';

export default {
  name: 'DataChart',
  components: {
    Chart,
  },
  props: {
    analysisConfig: {
      type: Object,
      default: () => ({}),
    },
    analysisData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      xAxisData: [],
      seriesData: [],
      legendData: [],
    };
  },
  computed: {
    calOptions() {
      const options = optionGen();

      merge(options, {
        legend: {
          show: true,
          data: this.legendData,
        },
        xAxis: { type: 'category', data: this.xAxisData },
        yAxis: {
          type: 'value',
        },
        grid: {
          top: 15,
          left: '1%',
          right: '1%',
          bottom: 30,
          containLabel: true,
        },
        series: this.seriesData,
      });

      return options;
    },
  },
  watch: {
    analysisConfig: {
      handler() {
        this.translateAnalysisData();
      },
      deep: true,
    },
    analysisData: {
      handler() {
        this.translateAnalysisData();
      },
      deep: true,
    },
  },
  mounted() {
    this.translateAnalysisData();
  },
  methods: {
    translateAnalysisData() {
      const { analysisData } = this;
      if (!analysisData || !analysisData.dataList) {
        return;
      }
      this.legendData = this.getLegendData();
      this.xAxisData = this.getXAxisData();
      this.seriesData = this.getSeriesData();
    },
    getLegendData() {
      const legendData = [];
      const { dateList, ltvList, dataList } = this.analysisData;
      dataList.forEach((item, idx) => {
        legendData.push(this.getLegendItemName(item, idx));
      });
      return legendData.slice(0, 10);
    },
    getLegendItemName(item, idx) {
      // const idxChar = getCharFromInt(idx);
      // return `${idxChar}${item.eventChineseName}`;
      return item.eventChineseName;
    },
    getXAxisData() {
      const xAxisData = [];
      const { chartShowType } = this.analysisConfig;
      const { dateList, ltvList } = this.analysisData;

      // 趋势
      if (chartShowType === 1) {
        return xAxisData.concat(ltvList);
      }

      // 对比
      if (chartShowType === 2) {
        return xAxisData.concat(dateList);
      }

      return xAxisData.slice(0, 10);
    },
    getSeriesData() {
      const { chartShowType, chartShowDate } = this.analysisConfig;
      const selectIdx = Number(chartShowDate);
      const { dateList, ltvList, dataList } = this.analysisData;
      const seriesData = [];

      dataList.forEach((item, idx) => {
        const seriesItem = {
          type: 'line',
          name: this.getLegendItemName(item, idx),
          data: [],
        };
        if (chartShowType === 1) {
          if (selectIdx === -1) {
            const [date, people, ...valueList] = item.summary;
            seriesItem.data = valueList;
          } else {
            const dateStr = dateList[selectIdx];
            const findDateData = item.details.find(detailItem => {
              const [detailDate, detailPeople] = detailItem;
              return detailDate === dateStr;
            });
            if (findDateData) {
              seriesItem.data = findDateData.slice(2);
            }
          }
        } else {
          const tmpArr = [];
          item.details.forEach(detailItem => {
            const [detailDate, detailPeople, ...valueList] = detailItem;
            tmpArr.push(valueList[selectIdx]);
          });
          seriesItem.data = tmpArr;
        }

        console.log('seriesItem', seriesItem);

        seriesData.push(seriesItem);
      });

      return seriesData.slice(0, 10);
    },
  },
};
</script>

<style scoped lang="less">
.chart-cont {
  width: 100%;
  height: 100%;
}
</style>
